webpackJsonp([114276838955818,60335399758886],{

/***/ 107:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"websiteName":"Birkenstab"}}},"layoutContext":{}}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(107);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Foot = _styledComponents2.default.footer.withConfig({
	    displayName: 'footer__Foot'
	})(['position:fixed;bottom:0;right:0;z-index:-1;padding:20px;background-color:', ';height:', 'px;color:#dddddd;columns:2 300px;'], function (props) {
	    return props.color;
	}, function (props) {
	    return props.height;
	});
	
	var Paragraph = _styledComponents2.default.p.withConfig({
	    displayName: 'footer__Paragraph'
	})(['margin-bottom:0.8rem;']);
	
	var FLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: 'footer__FLink'
	})(['color:#dddddd;']);
	
	var Footer = function Footer(_ref) {
	    var className = _ref.className,
	        color = _ref.color,
	        height = _ref.height;
	    return _react2.default.createElement(
	        Foot,
	        { className: className, color: color, height: height },
	        _react2.default.createElement(
	            Paragraph,
	            null,
	            'Copyright 2018 Moritz Beck (Birkenstab)'
	        ),
	        _react2.default.createElement(
	            Paragraph,
	            null,
	            _react2.default.createElement(
	                FLink,
	                { to: '/impressum' },
	                'Impressum'
	            )
	        ),
	        _react2.default.createElement(
	            Paragraph,
	            null,
	            _react2.default.createElement(
	                FLink,
	                { to: '/datenschutz' },
	                'Datenschutzerkl\xE4rung'
	            )
	        ),
	        _react2.default.createElement(
	            Paragraph,
	            null,
	            _react2.default.createElement(
	                FLink,
	                { to: '/links' },
	                'Links'
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _github = __webpack_require__(464);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _twitter = __webpack_require__(470);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidebar = _styledComponents2.default.header.withConfig({
	  displayName: 'header__Sidebar'
	})(['position:fixed;top:0;left:0;height:100%;text-align:center;background-color:', ';'], function (props) {
	  return props.color;
	});
	
	var Lettering = _styledComponents2.default.div.withConfig({
	  displayName: 'header__Lettering'
	})(['border-bottom:solid 0.02em;margin-bottom:0.5em;']);
	
	var Letter = _styledComponents2.default.div.withConfig({
	  displayName: 'header__Letter'
	})(['display:inline;color:#dddddd;']);
	
	var NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  displayName: 'header__NavLink'
	})(['color:#dddddd;display:block;']);
	
	var SocialMediaLogo = _styledComponents2.default.img.withConfig({
	  displayName: 'header__SocialMediaLogo'
	})(['height:0.7em;margin:0.7em;']);
	
	var Header = function Header(_ref) {
	  var className = _ref.className,
	      lettering = _ref.lettering,
	      color = _ref.color;
	  return _react2.default.createElement(
	    Sidebar,
	    { className: className, color: color },
	    _react2.default.createElement(
	      'nav',
	      null,
	      _react2.default.createElement(
	        NavLink,
	        { to: '/' },
	        _react2.default.createElement(
	          Lettering,
	          null,
	          Array.from(lettering.toUpperCase()).map(function (char, index) {
	            return _react2.default.createElement(
	              Letter,
	              { key: index },
	              char
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        NavLink,
	        { to: '/blog' },
	        'Blog'
	      ),
	      _react2.default.createElement(
	        NavLink,
	        { to: '/stuff' },
	        'Stuff'
	      ),
	      _react2.default.createElement(
	        NavLink,
	        { to: '/about' },
	        'About me'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/birkenstab', title: 'Github profile' },
	        _react2.default.createElement(SocialMediaLogo, { src: _github2.default, alt: 'Github Logo' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/birkenstab', title: 'Twitter profile' },
	        _react2.default.createElement(SocialMediaLogo, { src: _twitter2.default, alt: 'Twitter Logo' })
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  lettering: _propTypes2.default.string
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bar = _styledComponents2.default.div.withConfig({
	    displayName: 'underConstruction__Bar'
	})(['width:100%;height:50px;line-height:50px;text-align:center;background:repeating-linear-gradient(135deg,yellow 0px,yellow 20px,black 20px,black 40px);border-radius:10px;']);
	
	var Text = _styledComponents2.default.span.withConfig({
	    displayName: 'underConstruction__Text'
	})(['display:inline-block;font-size:2rem;color:yellow;height:100%;background-color:black;padding-left:10px;padding-right:10px;']);
	
	var UnderContruction = function UnderContruction() {
	    return _react2.default.createElement(
	        Bar,
	        null,
	        _react2.default.createElement(
	            Text,
	            null,
	            'Under Construction'
	        )
	    );
	};
	
	exports.default = UnderContruction;
	module.exports = exports['default'];

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsbGVkYnk9InNpbXBsZWljb25zLWdpdGh1Yi1pY29uIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGUgaWQ9InNpbXBsZWljb25zLWdpdGh1Yi1pY29uIj5HaXRIdWIgaWNvbjwvdGl0bGU+PHBhdGggc3R5bGU9ImZpbGw6ICNlZWVlZWUiIGQ9Ik0xMiAuMjk3Yy02LjYzIDAtMTIgNS4zNzMtMTIgMTIgMCA1LjMwMyAzLjQzOCA5LjggOC4yMDUgMTEuMzg1LjYuMTEzLjgyLS4yNTguODItLjU3NyAwLS4yODUtLjAxLTEuMDQtLjAxNS0yLjA0LTMuMzM4LjcyNC00LjA0Mi0xLjYxLTQuMDQyLTEuNjFDNC40MjIgMTguMDcgMy42MzMgMTcuNyAzLjYzMyAxNy43Yy0xLjA4Ny0uNzQ0LjA4NC0uNzI5LjA4NC0uNzI5IDEuMjA1LjA4NCAxLjgzOCAxLjIzNiAxLjgzOCAxLjIzNiAxLjA3IDEuODM1IDIuODA5IDEuMzA1IDMuNDk1Ljk5OC4xMDgtLjc3Ni40MTctMS4zMDUuNzYtMS42MDUtMi42NjUtLjMtNS40NjYtMS4zMzItNS40NjYtNS45MyAwLTEuMzEuNDY1LTIuMzggMS4yMzUtMy4yMi0uMTM1LS4zMDMtLjU0LTEuNTIzLjEwNS0zLjE3NiAwIDAgMS4wMDUtLjMyMiAzLjMgMS4yMy45Ni0uMjY3IDEuOTgtLjM5OSAzLS40MDUgMS4wMi4wMDYgMi4wNC4xMzggMyAuNDA1IDIuMjgtMS41NTIgMy4yODUtMS4yMyAzLjI4NS0xLjIzLjY0NSAxLjY1My4yNCAyLjg3My4xMiAzLjE3Ni43NjUuODQgMS4yMyAxLjkxIDEuMjMgMy4yMiAwIDQuNjEtMi44MDUgNS42MjUtNS40NzUgNS45Mi40Mi4zNi44MSAxLjA5Ni44MSAyLjIyIDAgMS42MDYtLjAxNSAyLjg5Ni0uMDE1IDMuMjg2IDAgLjMxNS4yMS42OS44MjUuNTdDMjAuNTY1IDIyLjA5MiAyNCAxNy41OTIgMjQgMTIuMjk3YzAtNi42MjctNS4zNzMtMTItMTItMTIiLz48L3N2Zz4K"

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsbGVkYnk9InNpbXBsZWljb25zLXR3aXR0ZXItaWNvbiIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlIGlkPSJzaW1wbGVpY29ucy10d2l0dGVyLWljb24iPlR3aXR0ZXIgaWNvbjwvdGl0bGU+PHBhdGggc3R5bGU9ImZpbGw6ICNlZWVlZWUiIGQ9Ik0yMy45NTQgNC41NjljLS44ODUuMzg5LTEuODMuNjU0LTIuODI1Ljc3NSAxLjAxNC0uNjExIDEuNzk0LTEuNTc0IDIuMTYzLTIuNzIzLS45NTEuNTU1LTIuMDA1Ljk1OS0zLjEyNyAxLjE4NC0uODk2LS45NTktMi4xNzMtMS41NTktMy41OTEtMS41NTktMi43MTcgMC00LjkyIDIuMjAzLTQuOTIgNC45MTcgMCAuMzkuMDQ1Ljc2NS4xMjcgMS4xMjRDNy42OTEgOC4wOTQgNC4wNjYgNi4xMyAxLjY0IDMuMTYxYy0uNDI3LjcyMi0uNjY2IDEuNTYxLS42NjYgMi40NzUgMCAxLjcxLjg3IDMuMjEzIDIuMTg4IDQuMDk2LS44MDctLjAyNi0xLjU2Ni0uMjQ4LTIuMjI4LS42MTZ2LjA2MWMwIDIuMzg1IDEuNjkzIDQuMzc0IDMuOTQ2IDQuODI3LS40MTMuMTExLS44NDkuMTcxLTEuMjk2LjE3MS0uMzE0IDAtLjYxNS0uMDMtLjkxNi0uMDg2LjYzMSAxLjk1MyAyLjQ0NSAzLjM3NyA0LjYwNCAzLjQxNy0xLjY4IDEuMzE5LTMuODA5IDIuMTA1LTYuMTAyIDIuMTA1LS4zOSAwLS43NzktLjAyMy0xLjE3LS4wNjcgMi4xODkgMS4zOTQgNC43NjggMi4yMDkgNy41NTcgMi4yMDkgOS4wNTQgMCAxMy45OTktNy40OTYgMTMuOTk5LTEzLjk4NiAwLS4yMDkgMC0uNDItLjAxNS0uNjMuOTYxLS42ODkgMS44LTEuNTYgMi40Ni0yLjU0OGwtLjA0Ny0uMDJ6Ii8+PC9zdmc+Cg=="

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: ', 'px;\n    font-size: ', 'px\n  '], ['\n    width: ', 'px;\n    font-size: ', 'px\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin-left: ', 'px;\n  '], ['\n    margin-left: ', 'px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    left: ', 'px;\n  '], ['\n    left: ', 'px;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(195);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _header = __webpack_require__(204);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _underConstruction = __webpack_require__(206);
	
	var _underConstruction2 = _interopRequireDefault(_underConstruction);
	
	var _footer = __webpack_require__(203);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sidebarColor = "#0c95ff";
	var sidebarWidth = 20;
	var sidebarMaxWidth = 360;
	var footerHeight = 120;
	
	var media = function media() {
	  return (0, _styledComponents.css)(['@media (min-width:', 'px){', '}'], 100 / sidebarWidth * sidebarMaxWidth, _styledComponents.css.apply(undefined, arguments));
	};
	
	var Sidebar = (0, _styledComponents2.default)(_header2.default).withConfig({
	  displayName: 'layouts__Sidebar'
	})(['width:', 'vw;font-size:3vw;', ''], sidebarWidth, media(_templateObject, sidebarMaxWidth, sidebarMaxWidth / sidebarWidth * 3));
	
	var MainContent = _styledComponents2.default.main.withConfig({
	  displayName: 'layouts__MainContent'
	})(['margin-left:', 'vw;padding:10px 20px;background-color:#ffffff;margin-bottom:', 'px;min-height:100vh;', ''], sidebarWidth, footerHeight, media(_templateObject2, sidebarMaxWidth));
	
	var Foot = (0, _styledComponents2.default)(_footer2.default).withConfig({
	  displayName: 'layouts__Foot'
	})(['left:', 'vw;', ''], sidebarWidth, media(_templateObject3, sidebarMaxWidth));
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{ name: 'description', content: 'Website of ' + data.site.siteMetadata.websiteName }, { name: 'author', content: 'Moritz Beck (Birkenstab)' }],
	      htmlAttributes: { "lang": "en" }
	    }),
	    _react2.default.createElement(Sidebar, { lettering: data.site.siteMetadata.websiteName, color: sidebarColor }),
	    _react2.default.createElement(
	      MainContent,
	      null,
	      _react2.default.createElement(_underConstruction2.default, null),
	      children()
	    ),
	    _react2.default.createElement(Foot, { color: sidebarColor, height: footerHeight })
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-bf3f29a5dc32cf3ea188.js